import { render } from "./Member_Receipts.vue?vue&type=template&id=72220680&scoped=true"
import script from "./Member_Receipts.vue?vue&type=script&lang=js"
export * from "./Member_Receipts.vue?vue&type=script&lang=js"

import "./Member_Receipts.vue?vue&type=style&index=0&id=72220680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72220680"]])

export default __exports__